import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-datasource-remote-query-agent-prompt', {
    marginBottom: '12px',
});

cssRule('.tb-details-datasource-remote-query-agent-block', {
    paddingTop: '12px',
    paddingBottom: 0,
});

cssRule('.tb-details-datasource-remote-query-agent-select-group-body', {
    paddingLeft: '21px',
});

cssRule('.tb-details-datasource-remote-query-agent-description', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    lineHeight: '16px',
});

cssRule('.tb-details-datasource-remote-query-agent-select-selector', {
    display: 'inline-block',
    width: '350px',
});

